import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'exclude',
  standalone: false
})
export class ExcludePipe implements PipeTransform {
  transform(value: object, keys: any[]): object {
    return Object.assign({}, value, ...keys.map(key => ({[key]: undefined})));
  }
}
